import { getDoctorDefaultImg } from "../../utils/defaultImage";
import { DoctorDto } from "@/src/web-api-client";
import { ImageWithFallback } from "../landing/ImageWithFallback";

interface DoctorImageProps {
  doctor: DoctorDto;
  hasAvatar?: string | null;
  avatarError?: string | undefined;
  className?: string;
}

export const DoctorImage = ({
  doctor,
  hasAvatar,
  avatarError,
  className
}: DoctorImageProps) => {
  const defaultImg = getDoctorDefaultImg(doctor.gender);

  const processed = hasAvatar
    ? doctor.processedUrl ?? null
    : doctor.originalUrl ?? null;

  const src =
    avatarError || doctor.avatarStatus === "empty"
      ? doctor.originalUrl
        ? doctor.originalUrl
        : defaultImg
      : processed && processed?.trim() !== ""
      ? processed
      : undefined;

  return (
    <ImageWithFallback
      src={src ?? doctor.originalUrl ?? defaultImg ?? undefined}
      alt={doctor.name}
      className={`${className} w-full object-cover object-center`}
      loading="lazy"
      onError={(e) => {
        const img = e.currentTarget as HTMLImageElement;

        if (!img.src.includes(defaultImg)) {
          img.onerror = null;
          img.src = defaultImg;
        }
      }}
    />
  );
};
